module.exports = __webpack_public_path__ + "static/media/img10.4ef7780c.jpg";